import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** History clock — a clock face with a curved arrow wrapping back
 *  over its top, signalling "step backwards through time". Distinct
 *  from `IcnStopwatch` so version-history surfaces don't share a
 *  glyph with scheduling. */
export function IcnHistory(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="history">
      <path d="M3 6.5A6 6 0 1 1 2.5 9.5" />
      <polyline points="2,3.5 3,6.5 6,5.5" />
      <line x1="8" y1="5.5" x2="8" y2="8.25" />
      <line x1="8" y1="8.25" x2="10" y2="9.5" />
    </Svg>
  );
}
